import { apiGet } from '../client';
import { BusinessBillingPageSchema, type BusinessBillingPage } from '../schemas';

/** Mirrors the backend's own default page size (business-portal-metrics.ts). */
const DEFAULT_BILLING_PAGE_SIZE = 20;

/** The owner's own billing ledger, newest paid first, keyset-paginated like listCustomers. */
export function listBillingRecords(
  cursor?: string,
  limit = DEFAULT_BILLING_PAGE_SIZE,
): Promise<BusinessBillingPage> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  return apiGet(`/v1/business/billing-records?${params.toString()}`, BusinessBillingPageSchema);
}
